<template>
  <v-container fluid fill-height class="grey lighten-3 pl-2 pr-2 pt-2">
    <v-layout row wrap>
      <v-flex xs12 v-if="show">
        <div class="mt-2 mb-5 ob-section-title-and-tabs">
          <h1 class="headline ob-section-title pl-3 pr-4 primary--text">
            <slot name="section-title"></slot>
          </h1>
          <v-tabs
            v-if="hasPerioade && perioadeTabs.length"
            hide-slider
            color="transparent"
            slider-color="accent"
            class="ml-2 ob-section-tabs"
            show-arrows
            v-model="selectedPerioadeTabIdentifier"
            :key="perioadeTabsUpdate">
            <v-tab
              v-for="item in perioadeTabs"
              :key="item._id"
              @click="_cbSelectPerioadeTab(item._id)"
              :ref="`perioadeTab-${item._id}`">
              {{ item.label }}
            </v-tab>
          </v-tabs>
          <v-tabs
            v-if="tabs.length"
            hide-slider
            color="transparent"
            slider-color="accent"
            class="ml-2 ob-section-tabs"
            show-arrows
            v-model="selectedTabIdentifier"
            :key="tabsUpdate">
            <v-tab
              v-for="item in tabs"
              :key="item._id"
              @click="_cbSelectTab(item._id)"
              :ref="`tab-${item._id}`">
              {{ item.label }}
            </v-tab>
          </v-tabs>
          <span v-else class="pl-3">Nu exista tab-uri definite</span>
        </div>
        <v-toolbar class="elevation-0 pa-0 pb-0 ob-section-toolbar transparent" extension-height="48" height="48">
          <v-toolbar-title>
            <v-toolbar-side-icon @click="_cbNukeData">
              <v-icon color="red">mdi-nuke</v-icon>
            </v-toolbar-side-icon>
            <v-toolbar-side-icon @click="_cbRefreshData">
              <v-icon color="blue">mdi-refresh</v-icon>
            </v-toolbar-side-icon>
            <v-toolbar-side-icon @click="_cbToggleExpandText">
              <v-icon color="blue" small>{{fullText ? 'mdi-arrow-collapse-horizontal' : 'mdi-arrow-expand-horizontal'}}</v-icon>
            </v-toolbar-side-icon>
            <slot name="toolbar-title"></slot>
          </v-toolbar-title>
          <v-text-field
            v-model="tableItemSearch"
            prepend-inner-icon="mdi-magnify"
            label="Cauta"
            single-line
            hide-details
            clearable
            solo flat
            class="pt-0">
          </v-text-field>
          <div slot="extension" class="ob-flex ob-align-center ob-justify-space-between ob-flex-1-1-100" v-if="extension">
            <span class="ob-ellipsis" style="max-width: min-content">
              ({{this.item.selected.length}}) Inregistrari selectate
            </span>
            <template v-if="extensionactions">
              <v-tooltip bottom>
                <span slot="activator">
                  <v-btn
                    flat
                    small
                    icon
                    :disabled="!item.selected.length || disabledToolbar"
                    @click="_cbEditItem">
                    <v-icon color="info" small>mdi-pencil</v-icon>
                  </v-btn>
                </span>
                <span>Modifica inregistrarile selectate</span>
              </v-tooltip>
              <v-tooltip bottom>
                <span slot="activator">
                  <v-btn
                    flat
                    icon
                    small
                    :disabled="!item.selected.length || disabledToolbar"
                    @click="_cbDeleteItems">
                    <v-icon color="error" small>mdi-delete</v-icon>
                  </v-btn>
                </span>
                <span>Sterge inregistrarile selectate</span>
              </v-tooltip>
              <v-tooltip bottom>
                <span slot="activator">
                  <v-btn
                    flat
                    icon
                    small
                    :disabled="!tabs.length || !add || disabledToolbar"
                    @click="_cbAddItem">
                    <v-icon color="success" small>mdi-plus</v-icon>
                  </v-btn>
                </span>
                <span>Adauga inregistrare noua</span>
              </v-tooltip>
              <v-tooltip bottom v-if="xlsx">
                <span slot="activator">
                  <v-btn
                    flat
                    icon
                    small
                    :disabled="!tabs.length || disabledToolbar"
                    @click="_cbOpenUploadDialog">
                    <v-icon color="success" small>mdi-upload</v-icon>
                  </v-btn>
                </span>
                <span>Incarca fisier XLS(X)</span>
              </v-tooltip>
              <v-tooltip bottom v-if="xlsxdown">
                <span slot="activator">
                  <v-btn
                    flat
                    icon
                    small
                    :disabled="!tabs.length || disabledToolbar"
                    @click="_cbDownloadXlsx">
                    <v-icon color="blue" small>mdi-download</v-icon>
                  </v-btn>
                </span>
                <span>Descraca fisier XLSX</span>
              </v-tooltip>
              <v-spacer></v-spacer>
              <v-tooltip bottom>
                <span slot="activator">
                  <v-btn icon flat small @click="_cbOpenImportHeadersDialog" :disabled="!importHeadersBtn || disabledToolbar">
                    <v-icon color="success" small>mdi-import</v-icon>
                  </v-btn>
                </span>
                <span>Importa capete de tabel din alta perioada</span>
              </v-tooltip>
              <v-tooltip bottom>
                <span slot="activator">
                  <v-btn icon flat small @click="_cbOpenPropDialog" :disabled="!tabs.length || !edit || disabledToolbar">
                    <v-icon color="success" small>mdi-plus</v-icon>
                  </v-btn>
                </span>
                <span>Adauga properietate noua</span>
              </v-tooltip>
              <v-autocomplete
                style="max-width: 250px"
                v-model="addProp.selected"
                :items="headers"
                :search-input.sync="headerSearch"
                hide-no-data
                label="Selecteaza proprietatea"
                return-object
                hide-details
                chips
                clearable
                dense
                solo flat
                single-line
                :disabled="disabledToolbar"
                item-text="label">
                <template slot="item" slot-scope="data">
                  <v-list-tile-action style="justify-content: center">
                    {{data.item.index}}
                  </v-list-tile-action>
                  <v-list-tile-title :class="{'font-weight-bold': addProp.selected && addProp.selected._id === data.item._id }">
                    {{data.item.label}}
                  </v-list-tile-title>
                  <v-list-tile-action style="justify-content: center">
                    <v-icon :color="data.item.visible ? 'blue lighten-2' : 'red lighten-2'" small>
                      {{data.item.visible ? 'mdi-eye' : 'mdi-eye-off'}}
                    </v-icon>
                  </v-list-tile-action>
                </template>
              </v-autocomplete>
              <v-tooltip bottom>
                <span slot="activator">
                  <v-btn flat icon small :disabled="!addProp.selected || addProp.selected.value === 'password' || disabledToolbar" @click="_cbToggleHeadVisibility">
                    <v-icon :color="addProp.selected && addProp.selected.visible ? 'blue lighten-2' : 'red lighten-2'" small>
                      {{addProp.selected && addProp.selected.visible ? 'mdi-eye' : 'mdi-eye-off'}}
                    </v-icon>
                  </v-btn>
                </span>
                <template v-if="addProp.selected">
                  <span v-if="addProp.selected.value !== 'password'">
                    {{addProp.selected && addProp.selected.visible ? `Ascunde ${addProp.selected.label}` : `Afiseaza ${addProp.selected.label}`}}
                  </span>
                  <span v-else>Nope! Parola nu poate fi vazuta niciodata! Oricum este criptata si nu te ajuta la nimic daca o vezi...</span>
                </template>
                <template v-else>
                  <span>Comuta vizibilitatea proprietatii selectate</span>
                </template>
              </v-tooltip>
              <v-tooltip bottom>
                <span slot="activator">
                  <v-btn flat icon small :disabled="!addProp.selected || disabledToolbar" @click="_cbEditProp">
                    <v-icon color="info" small>mdi-pencil</v-icon>
                  </v-btn>
                </span>
                <span>Modifica proprietatea selectata</span>
              </v-tooltip>
              <v-tooltip bottom>
                <span slot="activator">
                  <v-btn flat icon small :disabled="!addProp.selected || disabledToolbar" @click="_cbDeleteProp">
                    <v-icon color="error" small>mdi-delete</v-icon>
                  </v-btn>
                </span>
                <span>Sterge proprietatea selectata</span>
              </v-tooltip>
            </template>
          </div>
        </v-toolbar>

        <v-data-table
          no-data-text="Nu exista inregistrari"
          no-results-text="Nu exista inregistrari"
          rows-per-page-text="Inregistrari pe pagina"
          :headers="visibleHeaders"
          :items="items"
          class="elevation-0 ob-table ob-table-dark-header ob-check-adjust mb-5"
          :pagination.sync="pagination"
          item-key="_id"
          v-model="item.selected"
          :loading="loading"
          select-all
          :total-items="total"
          :rows-per-page-items="[ 5, 10, 25, 50, 100, 500, 1000, 1500, 2000, { 'text': 'Toate', 'value': -1 } ]">
          <template slot="headerCell" slot-scope="props">
            <v-tooltip top>
              <span slot="activator" dark class="secondary--text">
                <template v-if="!['verificare', 'computed'].includes(props.header.value)">
                  {{ props.header.label.toUpperCase() }}
                </template>
                <template v-else>
                  <v-icon class="secondary--text" style="opacity: 1">
                    {{ props.header.value === 'verificare' ? 'mdi-check' : 'mdi-calculator' }}
                  </v-icon>
                </template>
              </span>
              <span>{{props.header.meaning}}</span>
            </v-tooltip>
          </template>
          <template slot="items" slot-scope="props">
            <tr @click="_cbExpandRow(props)">
              <td @click.stop>
                <v-checkbox
                  v-model="props.selected"
                  color="accent"
                  hide-details>
                </v-checkbox>
              </td>
              <td v-for="head in visibleHeaders" :key="head._id" :class="{
                  'text-xs-left': head.align === 'left',
                  'text-xs-center': head.align === 'center',
                  'text-xs-right': head.align === 'right'
                }">

                <template v-if="head.value === 'itemNO'">
                  <span style="white-space: nowrap">{{ props.index + itemNO }} |</span>
                </template>
                <template v-else-if="head.value === 'jax'">
                  <vue-mathjax
                    :formula="props.item.jax"
                    :ref="`jax`"
                    v-if="props.item.jax">
                  </vue-mathjax>
                </template>
                <template v-else>
                  <template v-if="head.type === 'string' || head.type === 'enum'">
                    <template v-if="typeof props.item[head.value] === 'object'">
                      <v-tooltip bottom>
                        <div slot="activator" class="admin-table-data" :class="{'ob-ellipsis': !fullText}">
                          <div v-for="(value, key) in props.item[head.value]" :key="props.item._id + head.value + key" :class="{'grey--text': key === 'valoare_an'}">
                            {{ value }}
                          </div>
                        </div>
                        <div>
                          <div v-for="(value, key) in props.item[head.value]" :key="props.item._id + head.value + key + '_popup'" style="text-align: left">
                            {{ key }}: {{ value }}
                          </div>
                        </div>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <v-tooltip bottom>
                        <span
                          slot="activator"
                          :class="{
                            'ob-ellipsis': !fullText,
                            'primary--text font-weight-bold': tableItemSearch && tableItemSearch.length && String(props.item[head.value]).toLowerCase().includes(tableItemSearch.toLowerCase())
                          }">
                          <template v-if="['valoare', 'valoare_in', 'valoare_la', 'valoare_an'].includes(head.value)">
                            {{props.item[head.value] | number}}
                          </template>
                          <template v-else>
                            {{props.item[head.value]}}
                          </template>
                        </span>
                        <span>
                          <template v-if="['valoare', 'valoare_in', 'valoare_la', 'valoare_an'].includes(head.value)">
                            {{props.item[head.value] | number}}
                          </template>
                          <template v-else>
                            {{props.item[head.value]}}
                          </template>
                        </span>
                      </v-tooltip>
                    </template>
                  </template>

                  <template v-else-if="head.type === 'number'">
                    <template v-if="head.value !== 'index'">
                      {{ props.item[head.value] | number }}
                    </template>
                    <template v-else>
                      {{ props.item[head.value] | intNumber }}
                    </template>
                  </template>
                  <template v-else-if="head.type === 'boolean'">
                    <v-icon v-if="!!props.item[head.value]" color="success" small>
                      mdi-check
                    </v-icon>
                    <v-icon v-else color="error" small>
                      mdi-close
                    </v-icon>
                  </template>
                  <template v-else-if="head.type === 'link'">
                    <a :href="props.item[head.value]" target="_blank">
                      <v-icon>mdi-link</v-icon>
                    </a>
                  </template>
                  <template v-else-if="head.type === 'avatar'">
                    <v-avatar size="32px">
                      <img :src="props.item[head.value]" alt="user avatar">
                    </v-avatar>
                  </template>
                  <template v-else-if="head.type === 'datetime'">
                    <v-tooltip bottom>
                      <span slot="activator">
                        {{ props.item[head.value] | shortDate }}
                      </span>
                      <span>
                        {{ props.item[head.value] | longDate }}
                      </span>
                    </v-tooltip>
                  </template>
                  <template v-else-if="head.type === 'date'">
                    <v-tooltip bottom>
                      <span slot="activator">
                        {{ props.item[head.value] | shortDate }}
                      </span>
                      <span>
                        {{ props.item[head.value] | longDate }}
                      </span>
                    </v-tooltip>
                  </template>
                  <template v-else-if="head.type === 'time'">
                    {{ props.item[head.value] }}
                  </template>
                  <template v-else-if="head.type === 'object'">
                    <v-tooltip bottom v-if="!['colors', 'legendCount', 'legendLabels', 'title'].includes(head.value)">
                      <div slot="activator">
                        <div v-for="(value, key) in props.item[head.value]" :key="props.item._id + head.value + key" :class="{'grey--text': key === 'valoare_an'}">
                          {{value | number}}
                        </div>
                      </div>
                      <div>
                        <div v-for="(value, key) in props.item[head.value]" :key="props.item._id + head.value + key + '_popup'" style="text-align: right">
                          {{key}}: {{value | number}}
                        </div>
                      </div>
                    </v-tooltip>

                    <v-tooltip bottom v-else-if="head.value === 'colors'">
                      <div slot="activator">
                        <div v-for="(value, key) in props.item[head.value]" :key="props.item._id + head.value + key">
                          {{key}}
                          <span
                            v-for="(color, number) in value"
                            :key="key+number"
                            class="ml-1 mr-1"
                            :style="{'background-color': color}"
                            style="display: inline-flex; width: 1rem; height: 1rem; border-radius: 100%; border: thin solid #ccc; font-size: 8px; justify-content: center; align-items: center">
                            {{number}}
                          </span>
                        </div>
                      </div>
                      <div>
                        <div v-for="(value, key) in props.item[head.value]" :key="props.item._id + head.value + key + '_popup'" style="text-align: right">
                          {{key}}: {{value}}
                        </div>
                      </div>
                    </v-tooltip>
                    <v-tooltip bottom v-else-if="['legendCount', 'legendLabels'].includes(head.value)">
                      <div slot="activator">
                        <div v-for="(value, key) in props.item[head.value]" :key="props.item._id + head.value + key">
                          {{key}}:
                          <span
                            v-for="(content, index) in value"
                            :key="key+index"
                            class="ml-1 mr-1">
                            {{index}} - {{content}};
                          </span>
                        </div>
                      </div>
                      <div>
                        <div v-for="(value, key) in props.item[head.value]" :key="props.item._id + head.value + key + '_popup'" style="text-align: right">
                          {{key}}: {{value}}
                        </div>
                      </div>
                    </v-tooltip>
                    <v-tooltip bottom v-else-if="head.value === 'title'">
                      <div slot="activator">
                        <div v-for="(value, key) in props.item[head.value]" :key="props.item._id + head.value + key">
                          {{key}}: {{value}}
                        </div>
                      </div>
                      <div>
                        <div v-for="(value, key) in props.item[head.value]" :key="props.item._id + head.value + key + '_popup'" style="text-align: right">
                          {{key}}: {{value}}
                        </div>
                      </div>
                    </v-tooltip>
                  </template>

                  <template v-else-if="head.type === 'options'">
                    <v-tooltip bottom>
                      <div slot="activator">
                        {{Array.isArray(props.item[head.value]) ? props.item[head.value].join(', ') : '-lipsa-'}}
                      </div>
                      <div>
                        {{Array.isArray(props.item[head.value]) ? props.item[head.value].join(', ') : 'acesta proprietate nu exista pentru obiectul curent'}}
                      </div>
                    </v-tooltip>
                  </template>

                  <template v-else-if="head.type === 'array'">
                    <v-tooltip bottom>
                      <div slot="activator" class="ob-short-div">
                        <div v-for="(value, key) in props.item[head.value]" :key="props.item._id + head.value + key" :class="{'grey--text': key === 'valoare_an', 'mt-1': key !== 0}">
                          <template v-if="typeof value === 'object' && !relatedItems[head.value]">
                            <div v-for="(obValue, obProp) in value" :key="key + obProp">
                              {{ obValue }}
                            </div>
                          </template>
                          <template v-else>
                            {{ formatArrayItem(value, head.value) }}
                          </template>
                        </div>
                      </div>
                      <div>
                        <div v-for="(value, key) in props.item[head.value]" :key="props.item._id + head.value + key + '_popup'" style="text-align: right; border-bottom: thin dotted #ccc">
                          <template v-if="typeof value === 'object'">
                            <div v-for="(obValue, obProp) in value" :key="key + obProp">
                              {{ obProp }}: {{ obValue }}
                            </div>
                          </template>
                          <template v-else>
                            {{ key }}: {{ value }}
                          </template>
                        </div>
                      </div>
                    </v-tooltip>
                  </template>

                  <template v-else-if="head.type === 'files'">
                    <v-tooltip bottom>
                      <div slot="activator">
                        <div v-for="(value, key) in props.item[head.value]" :key="props.item._id + head.value + key" :class="{'grey--text': key === 'valoare_an', 'mt-1': key !== 0}">
                          <template v-if="typeof value === 'object'">
                            <div v-for="(obValue, obProp) in value" :key="key + obProp">
                              {{ obValue }}
                            </div>
                          </template>
                          <template v-else>
                            <a
                              href="#"
                              @click.prevent.stop="_cbGetFile(props.item._id, key, value)"
                              :class="{'ob-ellipsis': !fullText}">
                              {{ key }}: {{ value }}
                            </a>
                          </template>
                        </div>
                      </div>
                      <div>
                        <div v-for="(value, key) in props.item[head.value]" :key="props.item._id + head.value + key + '_popup'" style="text-align: right">
                          <template v-if="typeof value === 'object'">
                            <div v-for="(obValue, obProp) in value" :key="key + obProp">
                              {{ obProp }}: {{ obValue }}
                            </div>
                          </template>
                          <template v-else>
                            {{ key }}: {{ value }}
                          </template>
                        </div>
                      </div>
                    </v-tooltip>
                  </template>
                  <template v-else-if="head.type === 'file'">
                    <v-tooltip bottom>
                      <div slot="activator">
                        <div>
                          <template v-if="typeof head.value === 'object'">
                            <div v-for="(obValue, obProp) in value" :key="obProp">
                              {{ obValue }}
                            </div>
                          </template>
                          <template v-else>
                            <a
                              href="#"
                              @click.prevent.stop="_cbGetFile(props.item._id, 0, props.item[head.label])"
                              :class="{'ob-ellipsis': !fullText}">
                              {{ head.value }}
                            </a>
                          </template>
                        </div>
                      </div>
                      <div>
                        <div style="text-align: right">
                          <template v-if="typeof head.value === 'object'">
                            <div v-for="(obValue, obProp) in head.value" :key="obProp">
                              {{ obProp }}: {{ obValue }}
                            </div>
                          </template>
                          <template v-else>
                            {{ head.value }}
                          </template>
                        </div>
                      </div>
                    </v-tooltip>
                  </template>

                  <template v-else-if="head.type === 'dummy'">
                    <template v-if="type === 'users'">
                      <v-btn icon small @click.stop="emitDummyEvent(props.item)">
                        <v-icon color="accent" small>mdi-file-download</v-icon>
                      </v-btn>
                    </template>
                    <template v-if="type === 'adminmaps'">
                      <v-btn icon small @click.stop="emitDummyMapEvent(props.item)" v-if="head.value === 'map'">
                        <v-icon color="accent" small>mdi-map</v-icon>
                      </v-btn>
                      <v-img :aspect-ratio="16/9" max-height="100%" :src="host + '/ss/' + props.item._id + '.png?' + (new Date().getTime())" v-if="head.value === 'preview'">
                      </v-img>
                    </template>
                  </template>

                  <template v-else-if="head.type === 'colors'">
                    custom colors
                  </template>
                </template>
              </td>
            </tr>
          </template>
          <template slot="expand" slot-scope="props">
            <slot
              name="ob-row-expansion"
              v-if="['judete', 'municipii', 'orase', 'comune'].includes(type)"
              :_id="props.item._id"
              :cifop="props.item.cif_op"
              :cifos="props.item.cif_os"
              :denumire="props.item.denumire_apl"
              :judet="props.item.judet">
            </slot>
            <slot
              name="ob-row-expansion"
              v-if="['users'].includes(type)"
              :_id="props.item._id">
            </slot>
            <slot
              name="ob-row-expansion"
              v-if="['cifuri'].includes(type)"
              :cifItem="props.item"
              :perioada="tabs[selectedTab].label">
            </slot>
            <slot
              name="ob-row-expansion"
              v-if="['rapoarte'].includes(type)"
              :raportItem="props.item">
            </slot>
          </template>
          <template slot="pageText" slot-scope="props">
            Inregistrarile {{ props.pageStart }} - {{ props.pageStop }} din {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12>
        <slot name="map"></slot>
      </v-flex>
    </v-layout>

    <template v-if="dialogs">
      <ob-dialog :value="addProp.dialog" :max-width="500" @close="_cbClosePropDialog" key="add-prop">
        <template slot="title">
          <span v-if="addProp.type === 'add'">Adauga o proprietate noua:</span>
          <span v-else>Modifica proprietatea selectata:</span>
        </template>
        <template slot="content">
          <v-form v-model="addProp.valid" ref="addPropForm">
            <v-layout column>
              <!-- denumire -->
              <v-flex xs12 mb-2>
                <ob-form-field title="Denumire proprietate">
                  <v-text-field
                    hint="ID existent in xls(x)"
                    clearable
                    :rules="getRules2AddValueHeader()"
                    counter="25"
                    :value="addProp.values.value"
                    @input="setValue('addProp', 'value', $event)"
                    :disabled="addProp.type === 'edit' && restrictedHeaders.includes(addProp.selected.value)">
                  </v-text-field>
                </ob-form-field>
              </v-flex>
              <!-- explicatie -->
              <v-flex xs12 mb-2>
                <ob-form-field title="Explicatie proprietate">
                  <v-text-field
                    placeholder="Explicatie proprietate"
                    hint="Denumire vizibila utilizatorilor"
                    clearable
                    :rules="addProp.rules.label"
                    :value="addProp.values.label"
                    @input="setValue('addProp', 'label', $event)">
                  </v-text-field>
                </ob-form-field>
              </v-flex>
              <!-- tooltip -->
              <v-flex xs12 mb-2>
                <ob-form-field title="Tooltip">
                  <v-text-field
                    placeholder="Tooltip"
                    hint="Denumire vizibila utilizatorilor la hover pe table header"
                    clearable
                    :rules="addProp.rules.label"
                    :value="addProp.values.meaning"
                    @input="setValue('addProp', 'meaning', $event)">
                  </v-text-field>
                </ob-form-field>
              </v-flex>
              <!-- index -->
              <v-flex xs12 mb-2>
                <ob-form-field title="Index">
                  <v-text-field
                    placeholder="Index"
                    hint="Ordinea de afisare in tabel: 1 - primul din stanga"
                    clearable
                    :rules="addProp.rules.label"
                    :value="addProp.values.index"
                    @input="setValue('addProp', 'index', $event)"
                    type="number"
                    min="minIndex">
                  </v-text-field>
                </ob-form-field>
              </v-flex>
              <!-- tip -->
              <v-flex xs12 mb-2>
                <ob-form-field title="Tip informatie">
                  <v-radio-group
                    v-model="addProp.values.type"
                    :disabled="addProp.type === 'edit' && restrictedHeaders.includes(addProp.selected.value)"
                    class="ob-radio-group-grid columns-4">
                    <v-radio
                      v-for="item in propTypes"
                      :key="item"
                      :label="item"
                      :value="item"
                      color="primary">
                    </v-radio>
                  </v-radio-group>
                </ob-form-field>
              </v-flex>
              <!-- enum -->
              <v-flex xs12 mb-2>
                <ob-form-field title="Lista valori (tip enum)" v-if="addProp.values.type === 'enum'">
                  <template>
                    <v-text-field
                      placeholder="Lista valori enumerabile"
                      hint="Lista din care se pot alege valori pentru aceasta proprietate. Format: A, B C, D_E_F"
                      clearable
                      :rules="addProp.rules.enum"
                      :value="addProp.values.enum"
                      @input="setValue('addProp', 'enum', $event)">
                    </v-text-field>
                  </template>
                </ob-form-field>
              </v-flex>
              <!-- no default -->
              <v-flex xs12 mb-2>
                <ob-form-field title="Valoare implicita">
                  <v-radio-group
                    v-model="addProp.values.noDefault"
                    :disabled="addProp.type === 'edit' && restrictedHeaders.includes(addProp.selected.value)">
                    <v-radio
                      label="FARA valoare implicita"
                      :value="true"
                      color="error">
                    </v-radio>
                    <v-radio
                      label="CU valoare implicita"
                      :value="false"
                      color="success">
                    </v-radio>
                  </v-radio-group>
                </ob-form-field>
              </v-flex>
              <!-- default -->
              <v-flex xs12 mb-2>
                <ob-form-field title="Valoare implicita" v-if="!addProp.values.noDefault">
                  <v-text-field
                    placeholder="Valoare implicita"
                    hint="Valoare implicita care sa fie atribuita inregistrarilor deja exitente. Depinde de tipul proprietatii (ex.: pt boolean -> camp gol = false, camp completat cu orice = true)"
                    clearable
                    :value="addProp.values.default"
                    @input="setValue('addProp', 'default', $event)"
                    :disabled="(addProp.type === 'edit' && restrictedHeaders.includes(addProp.selected.value)) || addProp.values.noDefault">
                  </v-text-field>
                  <v-text-field
                    placeholder="Valoare transformata"
                    hint="Valoarea efectiva atribuita obiectelor bazata pe tipul proprietatii"
                    disabled
                    :value="transformValue(addProp.values.default)">
                  </v-text-field>
                </ob-form-field>
              </v-flex>
              <!-- sort -->
              <v-flex xs12 mb-2>
                <ob-form-field title="Sortare">
                  <v-radio-group
                    v-model="addProp.values.sortable"
                    :disabled="addProp.type === 'edit' && restrictedHeaders.includes(addProp.selected.value)">
                    <v-radio
                      label="NU SE POT sorta datele dupa aceasta proprietate"
                      :value="false"
                      color="error">
                    </v-radio>
                    <v-radio
                      label="SE POT sorta datele dupa aceasta proprietate"
                      :value="true"
                      color="success">
                    </v-radio>
                  </v-radio-group>
                </ob-form-field>
              </v-flex>
              <!-- visibiliy -->
              <v-flex xs12 mb-2>
                <ob-form-field title="Vizibilitate">
                  <v-radio-group
                    v-model="addProp.values.visible"
                    :disabled="addProp.type === 'edit' && restrictedHeaders.includes(addProp.selected.value)">
                    <v-radio
                      label="Proprietate vizibila in tabel"
                      :value="true"
                      color="success">
                    </v-radio>
                    <v-radio
                      label="Proprietate ascunsa in tabel"
                      :value="false"
                      color="error">
                    </v-radio>
                  </v-radio-group>
                </ob-form-field>
              </v-flex>
              <!-- align -->
              <v-flex xs12 mb-2>
                <ob-form-field title="Aliniere">
                  <v-radio-group
                    v-model="addProp.values.align"
                    :disabled="addProp.type === 'edit' && restrictedHeaders.includes(addProp.selected.value)"
                    class="ob-radio-group-grid columns-3">
                    <v-radio
                      v-for="(value, romana) in { stanga: 'left', centru: 'center', dreapta: 'right' }"
                      :key="value"
                      :label="romana"
                      :value="value"
                      color="primary">
                    </v-radio>
                  </v-radio-group>
                </ob-form-field>
              </v-flex>
              <!-- rules -->
              <v-flex xs12 mb-2>
                <ob-form-field title="Reguli validare date">
                  <div class="ob-grid columns-2 mb-2">
                    <v-switch
                      color="primary"
                      label="Required"
                      value="required"
                      v-model="addProp.values.rules"
                      hide-details
                      :disabled="addProp.type === 'edit' && restrictedHeaders.includes(addProp.selected.value)">
                    </v-switch>
                    <v-switch
                      color="primary"
                      label="Unique"
                      value="unique"
                      v-model="addProp.values.rules"
                      hide-details
                      :disabled="addProp.type === 'edit' && restrictedHeaders.includes(addProp.selected.value)">
                    </v-switch>
                  </div>
                </ob-form-field>
              </v-flex>
            </v-layout>
          </v-form>
        </template>
        <template slot="actions">
          <v-spacer></v-spacer>
          <v-btn flat @click="_cbClosePropDialog">Anulare</v-btn>
          <v-btn flat color="primary" @click="_cbAddProp" :disabled="!addProp.valid">Salvare</v-btn>
        </template>
      </ob-dialog>

      <ob-dialog :value="confirm.dialog" :max-width="500" title-class="error--text" @close="_cbCloseConfirm" key="confirm">
        <template slot="title">
          Stergere
        </template>
        <template slot="content">
          <v-alert type="error" :value="true">Aceasta operatie este ireversibila! Esti sigur ca vrei sa continui?</v-alert>
        </template>
        <template slot="actions">
          <v-spacer></v-spacer>
          <v-btn flat @click="_cbCloseConfirm">Anulare</v-btn>
          <v-btn flat color="error" @click="_cbDoConfirm">Confirma</v-btn>
        </template>
      </ob-dialog>

      <ob-dialog :value="item.dialog" :max-width="500" @close="_cbCloseItemDialog" key="item">
        <template slot="title">
          <span v-if="item.type === 'add'">Adauga o inregistrare:</span>
          <span v-else>Modifica inregistrarea {{this.item.currentIndex + 1}} selectata:</span>
        </template>
        <template slot="content">
          <v-scroll-x-transition mode="out-in" tag="div">
            <v-form v-model="item.valid[item.currentIndex]" ref="itemForm" :key="item.values[item.currentIndex]._id" v-if="item.currentIndex !== null">
              <v-layout column>
                <template v-for="head in filteredHeaders">
                  <v-flex xs12 mb-2 :key="`${item.values[item.currentIndex]._id}-${head.value}`">
                    <ob-form-field :title="head.label">
                      <template v-if="head.type === 'enum'">
                        <v-radio-group v-model="item.values[item.currentIndex][head.value]" :key="head.value">
                          <v-radio
                            v-for="value in head.enum"
                            :key="value"
                            :label="value"
                            :value="value">
                          </v-radio>
                        </v-radio-group>
                      </template>
                      <template v-else-if="head.type === 'array'">
                        <p :key="head.value + 'p'" class="mt-3 mb-0">{{head.meaning}}</p>
                        <v-autocomplete
                          v-if="head.value === 'cifuri'"
                          class="ob-autocomplete-in-form"
                          :key="head.value"
                          v-model="item.values[item.currentIndex][head.value]"
                          :items="relatedItems[head.value]"
                          :search-input.sync="relatedSearch"
                          cache-items
                          flat
                          hide-no-data
                          hide-details
                          :label="head.value"
                          solo
                          item-text="text"
                          item-value="_id"
                          multiple
                          chips
                          hide-selected
                          clearable>
                          <template v-slot:no-data>
                            <v-list-tile>
                              <v-list-tile-title>
                                Nu exista date pentru cautarea efectuata
                              </v-list-tile-title>
                            </v-list-tile>
                          </template>
                          <template v-slot:selection="{ item, selected }">
                            <v-chip
                              :selected="selected"
                              close
                              @input="_cbRemoveItemFormRelatedSelection(item._id, head.value)">
                              <v-icon left small color="primary">mdi-domain</v-icon>
                              <span v-text="item.text"></span>
                            </v-chip>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-tile-avatar class="headline font-weight-light">
                              {{ item.text.charAt(0) }}
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title v-text="item.text"></v-list-tile-title>
                              <v-list-tile-sub-title v-text="item._id"></v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-icon>mdi-domain</v-icon>
                            </v-list-tile-action>
                          </template>
                        </v-autocomplete>

                        <v-autocomplete
                          v-if="head.value === 'rapoarte'"
                          class="ob-autocomplete-in-form"
                          :key="head.value"
                          v-model="item.values[item.currentIndex][head.value]"
                          :items="relatedItems[head.value]"
                          :search-input.sync="relatedSearchRapoarte"
                          cache-items
                          flat
                          hide-no-data
                          hide-details
                          :label="head.value"
                          solo
                          item-text="denumire"
                          item-value="_idCuPerioada"
                          multiple
                          chips
                          hide-selected
                          clearable>
                          <template v-slot:no-data>
                            <v-list-tile>
                              <v-list-tile-title>
                                Nu exista date pentru cautarea efectuata
                              </v-list-tile-title>
                            </v-list-tile>
                          </template>
                          <template v-slot:selection="{ item, selected }">
                            <v-chip
                              :selected="selected"
                              close
                              @input="_cbRemoveItemFormRelatedSelection(item._idCuPerioada, head.value)">
                              <v-icon left small color="primary">{{ item.public ? 'mdi-parking' : 'mdi-file-multiple' }}</v-icon>
                              <span v-text="translateUI(item.denumire, lang) + ' ' + item.perioada"></span>
                            </v-chip>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-tile-action class="body-1">
                              {{item.an}}
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title style="max-width: 308px" class="caption font-weight-regular">
                                {{ translateUI(item.denumire, lang) }}
                              </v-list-tile-title>
                              <v-list-tile-sub-title style="max-width: 308px" class="caption">
                                {{item.denumire}}
                              </v-list-tile-sub-title>
                              <v-list-tile-sub-title class="caption">
                                <v-icon color="primary" size="12">
                                  {{ item.public ? 'mdi-parking' : 'mdi-file-multiple' }}
                                </v-icon>
                                <v-icon :color="item.vizibil ? 'success' : 'error'" size="12">
                                  {{ item.vizibil ? 'mdi-eye' : 'mdi-eye-off' }}
                                </v-icon>
                                <span>
                                  {{item.perioada}}
                                </span>
                                -
                                <span :class="{'primary--text': item.tab === 'rapoarte', 'accent--text': item.tab === 'agregate'}">
                                  {{item.tab}}
                                </span>
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action class="body-1">
                              {{item.trimestru}}
                            </v-list-tile-action>
                          </template>
                        </v-autocomplete>

                        <v-autocomplete
                          v-if="head.value === 'harti'"
                          class="ob-autocomplete-in-form"
                          :key="head.value"
                          v-model="item.values[item.currentIndex][head.value]"
                          :items="relatedItems[head.value]"
                          :search-input.sync="relatedSearchHarti"
                          cache-items
                          flat
                          hide-no-data
                          hide-details
                          :label="head.value"
                          solo
                          item-text="denumire"
                          item-value="_id"
                          multiple
                          chips
                          hide-selected
                          clearable>
                          <template v-slot:no-data>
                            <v-list-tile>
                              <v-list-tile-title>
                                Nu exista date pentru cautarea efectuata
                              </v-list-tile-title>
                            </v-list-tile>
                          </template>
                          <template v-slot:selection="{ item, selected }">
                            <v-chip
                              :selected="selected"
                              close
                              @input="_cbRemoveItemFormRelatedSelection(item._id, head.value)">
                              <v-icon left small color="primary">mdi-domain</v-icon>
                              <span v-text="item.denumire"></span>
                            </v-chip>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-tile-avatar class="headline font-weight-light">
                              {{ item.denumire.charAt(0) }}
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title v-text="item.denumire"></v-list-tile-title>
                              <v-list-tile-sub-title v-text="item._id"></v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-icon>mdi-domain</v-icon>
                            </v-list-tile-action>
                          </template>
                        </v-autocomplete>

                        <template v-if="head.value === 'tip_apl'">
                          <template v-for="tip in relatedItems[head.value]">
                            <v-switch
                              :key="tip"
                              v-model="item.values[item.currentIndex][head.value]"
                              :label="tip"
                              :value="tip"
                              hide-details>
                            </v-switch>
                          </template>
                        </template>
                      </template>
                      <template v-else-if="head.type === 'options' && head.value === 'perioade'">
                        <p :key="`${item.values[item.currentIndex]._id}-${head.value}_title`" class="mt-4">Perioade:</p>
                        <v-layout row wrap class="light--text" :key="`${item.values[item.currentIndex]._id}-${head.value}_options`">
                          <v-flex xs3>
                            <v-checkbox v-model="item.values[item.currentIndex][head.value]" label="T1" value="T1" :key="`${item.values[item.currentIndex]._id}-${head.value}_1`" class="mt-0">
                            </v-checkbox>
                          </v-flex>
                          <v-flex xs3>
                            <v-checkbox v-model="item.values[item.currentIndex][head.value]" label="T2" value="T2" :key="`${item.values[item.currentIndex]._id}-${head.value}_2`" class="mt-0">
                            </v-checkbox>
                          </v-flex>
                          <v-flex xs3>
                            <v-checkbox v-model="item.values[item.currentIndex][head.value]" label="T3" value="T3" :key="`${item.values[item.currentIndex]._id}-${head.value}_3`" class="mt-0">
                            </v-checkbox>
                          </v-flex>
                          <v-flex xs3>
                            <v-checkbox v-model="item.values[item.currentIndex][head.value]" label="T4" value="T4" :key="`${item.values[item.currentIndex]._id}-${head.value}_4`" class="mt-0">
                            </v-checkbox>
                          </v-flex>
                        </v-layout>
                      </template>
                      <template v-else-if="head.type === 'options' && head.value === 'tip_apl'">
                        <p :key="`${item.values[item.currentIndex]._id}-${head.value}_title`" class="mt-2">Tip APL:</p>
                        <v-layout row wrap class="light--text" :key="`${item.values[item.currentIndex]._id}-${head.value}_options`">
                          <v-flex xs3>
                            <v-checkbox v-model="item.values[item.currentIndex][head.value]" label="Judet" value="Judet" :key="`${item.values[item.currentIndex]._id}-${head.value}_1`" class="mt-0">
                            </v-checkbox>
                          </v-flex>
                          <v-flex xs3>
                            <v-checkbox v-model="item.values[item.currentIndex][head.value]" label="Municipiu" value="Municipiu" :key="`${item.values[item.currentIndex]._id}-${head.value}_2`" class="mt-0">
                            </v-checkbox>
                          </v-flex>
                          <v-flex xs3>
                            <v-checkbox v-model="item.values[item.currentIndex][head.value]" label="Oras" value="Oras" :key="`${item.values[item.currentIndex]._id}-${head.value}_3`" class="mt-0">
                            </v-checkbox>
                          </v-flex>
                          <v-flex xs3>
                            <v-checkbox v-model="item.values[item.currentIndex][head.value]" label="Comuna" value="Comuna" :key="`${item.values[item.currentIndex]._id}-${head.value}_3`" class="mt-0">
                            </v-checkbox>
                          </v-flex>
                        </v-layout>
                      </template>
                      <template v-else-if="head.type === 'files'">
                        <p class="mt-4 mb-0" :key="`${item.values[item.currentIndex]._id}-${head.value}-p`">Fisiere</p>
                        <input
                          type="file"
                          class="mb-3"
                          multiple
                          @change="_cbItemFilesAdded($event, item.currentIndex, head.value, head.type)"
                          :key="`${item.values[item.currentIndex]._id}-${head.value}`">

                        <template v-if="Array.isArray(item.values[item.currentIndex][head.value])">
                          <p
                            class="ma-0"
                            v-for="(file, fIndex) in item.values[item.currentIndex][head.value]"
                            :key="`${item.values[item.currentIndex]._id}-${head.value}-f${fIndex}`">
                            <v-btn
                              flat
                              icon
                              :color="!fileIsToDelete(head.value, item.currentIndex, file) ? 'error' : 'info'"
                              small
                              @click="_cbToggleItemRemoveFile(item.currentIndex, head.value, fIndex, file)">
                              <v-icon small>
                                {{ !fileIsToDelete(head.value, item.currentIndex, file) ? 'mdi-delete-forever' : 'mdi-undo' }}
                              </v-icon>
                            </v-btn>
                            <span :class="{'ob-line-through': fileIsToDelete(head.value, item.currentIndex, file)}">
                              {{ file.name || file }}
                            </span>
                          </p>
                        </template>
                      </template>
                      <template v-else-if="head.type === 'file'">
                        <p class="mt-4 mb-0" :key="`${item.values[item.currentIndex]._id}-${head.value}-p`">Fisier</p>
                        <input
                          type="file"
                          class="mb-3"
                          @change="_cbItemFilesAdded($event, item.currentIndex, head.value, head.type)"
                          :key="`${item.values[item.currentIndex]._id}-${head.value}`">
                      </template>
                      <template v-else>
                        <v-text-field
                          v-if="head.type !== 'boolean' && head.value !== 'password'"
                          :type="head.type"
                          :placeholder="head.label"
                          :hint="head.meaning"
                          persistent-hint
                          :rules="getRules(
                            head.rules,
                            itemsValues(head.value),
                            item.type === 'add' ? null : item.selected[item.currentIndex][head.value]
                          )"
                          clearable
                          v-model="item.values[item.currentIndex][head.value]">
                        </v-text-field>
                        <v-text-field
                          v-if="head.value === 'password'"
                          :type="head.type"
                          :placeholder="head.label"
                          :hint="item.type === 'add' ? head.meaning : 'Completeaza doar daca vrei sa schimbi parola utilizatorului!'"
                          persistent-hint
                          :rules="getRules(
                            head.rules,
                            itemsValues(head.value),
                            item.type === 'add' ? null : item.selected[item.currentIndex][head.value],
                            head.value,
                            item.type
                          )"
                          clearable
                          v-model="item.values[item.currentIndex][head.value]"
                          append-icon="mdi-lock-reset"
                          @click:append="generatePassword">
                        </v-text-field>
                        <v-switch
                          v-if="head.type === 'boolean'"
                          color="primary"
                          :label="head.label"
                          v-model="item.values[item.currentIndex][head.value]"
                          hide-details>
                        </v-switch>
                      </template>
                    </ob-form-field>
                  </v-flex>
                  <!-- <template v-if="head.type === 'colors'">
                    <ob-color-picker :key="`${item.values[item.currentIndex]._id}-${head.value}-p`"></ob-color-picker>
                  </template> -->
                </template>
              </v-layout>
            </v-form>
          </v-scroll-x-transition>
        </template>
        <template slot="actions">
          <template v-if="item.type === 'edit'">
            <v-btn icon flat small @click="_cbNavEditItem(-1)">
              <v-icon small color="primary">mdi-arrow-left-bold-circle-outline</v-icon>
            </v-btn>
            <span class="caption">{{item.currentIndex + 1}} din {{item.selected.length}}</span>
            <v-btn icon flat small @click="_cbNavEditItem(1)">
              <v-icon small color="primary">mdi-arrow-right-bold-circle-outline</v-icon>
            </v-btn>
          </template>
          <v-spacer></v-spacer>
          <v-btn flat @click="_cbCloseItemDialog">Anulare</v-btn>
          <v-btn flat color="primary" @click="_cbSaveItem" :disabled="!item.valid.reduce((v, i) => (v = !i ? i : v), true)">Salvare</v-btn>
        </template>
      </ob-dialog>

      <ob-dialog :value="upload.dialog" :max-width="500" @close="_cbCloseUploadDialog(false)" key="upload">
        <template slot="title">
          Incarca un fisier XLS(X):
          <v-progress-linear
            :active="loading"
            :indeterminate="true"
            color="primary"
            height="2">
          </v-progress-linear>
        </template>
        <template slot="content">
          <form ref="fileForm">
            <input type="file" ref="file">
          </form>
        </template>
        <template slot="actions">
          <v-spacer></v-spacer>
          <v-btn flat @click="_cbCloseUploadDialog(false)">Anulare</v-btn>
          <v-btn flat color="primary" :disabled="loading" @click="_cbCloseUploadDialog(true)">Incarca</v-btn>
        </template>
      </ob-dialog>

      <ob-dialog :value="upload.props.dialog" :max-width="500" @close="_cbCloseUploadPropsDialog(false)" key="import-headers">
        <template slot="title">
          Alegeti proprietatile pentru import
        </template>
        <template slot="content">
          <v-layout row wrap>
            <v-flex xs6 class="pa-1">
              <v-list dense class="fill-height">
                <v-subheader>Proprietati acceptate</v-subheader>
                <ob-draggable v-model="upload.props.accepted" group="props" :move="_cbPullAcceptedItem" style="min-height: 95%">
                  <v-hover v-for="(head, index) in upload.props.accepted" :key="head._id">
                    <v-list-tile slot-scope="{ hover }" style="cursor: pointer" :class="{ 'elevation-1': hover }">
                      <v-list-tile-action>
                        <v-icon small class="grey--text">mdi-cursor-move</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{head.value}}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn flat icon :disabled="head.idx === -1" @click="_cbMoveBetweenLists(head, index, 'accepted')">
                          <v-icon class="error--text">mdi-arrow-right-bold-circle-outline</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-hover>
                </ob-draggable>
              </v-list>
            </v-flex>
            <v-flex xs6 class="pa-1">
              <v-list dense class="fill-height">
                <v-subheader>Proprietati refuzate</v-subheader>
                <ob-draggable v-model="upload.props.rejected" group="props" :move="_cbPullRejectedItem" style="min-height: 95%">
                  <v-hover v-for="(head, index) in upload.props.rejected" :key="head._id">
                    <v-list-tile slot-scope="{ hover }" style="cursor: pointer" :class="{ 'elevation-1': hover }">
                      <v-list-tile-action>
                        <v-btn flat icon @click="_cbMoveBetweenLists(head, index, 'rejected')" :disabled="head.idx === -1">
                          <v-icon class="success--text">mdi-arrow-left-bold-circle-outline</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{head.value}}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon small class="grey--text">mdi-cursor-move</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-hover>
                </ob-draggable>
              </v-list>
            </v-flex>
            <v-flex xs6 class="pa-1">
              <v-list dense>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      Refuza tot
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn flat icon @click="_cbImportAllProps(-1)">
                      <v-icon class="error--text">mdi-skip-forward</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </v-flex>
            <v-flex xs6 class="pa-1">
              <v-list dense>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-btn flat icon @click="_cbImportAllProps(1)">
                      <v-icon class="success--text">mdi-skip-backward</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      Accepta tot
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
          </v-layout>
        </template>
        <template slot="actions">
          <v-spacer></v-spacer>
          <v-btn flat @click="_cbCloseUploadPropsDialog(false)">Anulare</v-btn>
          <v-btn flat color="primary" @click="_cbCloseUploadPropsDialog(true)">Salveaza</v-btn>
        </template>
      </ob-dialog>

      <ob-dialog :value="upload.import.dialog" :max-width="500" @close="_cbCloseErrorsDialog(-1)" key="import-errors">
        <template slot="title">
          Unele inregistrari nu sunt valide:
        </template>
        <template slot="content">
          <v-subheader color="error">
            Inregistrari invalide: {{upload.import.errors.length}}
          </v-subheader>
          <v-list dense>
            <template v-for="err in upload.import.errors">
              <v-subheader :key="`head-${err.id}`">Nr.crt. {{err.nrcrt}}</v-subheader>
              <v-list-tile v-for="(msg, mi) in err.messages" :key="`row-${err.id}-${mi}`">
                <v-list-tile-action>
                  <v-icon class="error--text">mdi-alert-decagram</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span>{{msg.head}}</span> - <span>{{msg.msg}}</span>
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </template>
        <template slot="actions">
          <v-spacer></v-spacer>
          <v-btn flat @click="_cbCloseErrorsDialog(-1)">Anulare</v-btn>
          <v-btn flat color="warning" @click="_cbCloseErrorsDialog(0)">Salveaza cu erori</v-btn>
          <v-btn flat color="primary" @click="_cbCloseErrorsDialog(1)">Salveaza doar valid</v-btn>
        </template>
      </ob-dialog>

      <ob-dialog :value="nuke.dialog" :max-width="500" title-class="error--text" @close="_cbCloseNuke" key="nuke">
        <template slot="title">
          Stergere date din intreaga perioada selectata
        </template>
        <template slot="content">
          <v-alert type="error" :value="true">Aceasta operatie este ireversibila! Esti sigur ca vrei sa continui?</v-alert>

          <v-checkbox v-model="nuke.confirm" label="Da, inteleg ca voi sterge toate datele din aceasta colectie pentru perioada selectata."></v-checkbox>
        </template>
        <template slot="actions">
          <v-spacer></v-spacer>
          <v-btn flat @click="_cbCloseNuke">Anulare</v-btn>
          <v-btn flat color="error" @click="_cbDoNuke" :disabled="!nuke.confirm">Confirma</v-btn>
        </template>
      </ob-dialog>

      <ob-dialog :value="importHeaders.dialog" :max-width="500" @close="_cbCloseImportHeaders" key="importHeaders">
        <template slot="title">
          Importa capete de tabel din alta perioada
        </template>
        <template slot="content">
          <v-radio-group
            v-model="importHeaders.perioada"
            class="ob-radio-group-grid columns-4">
            <v-radio
              v-for="tab in perioadeTabs"
              :key="tab._id"
              :label="tab.label"
              :value="tab._id"
              :disabled="tab._id === selectedPerioadeTabID"
              color="primary">
            </v-radio>
          </v-radio-group>
        </template>
        <template slot="actions">
          <v-spacer></v-spacer>
          <v-btn flat @click="_cbCloseImportHeaders">Anulare</v-btn>
          <v-btn flat color="error" @click="_cbDoImportHeaders" :disabled="!importHeaders.perioada">Confirma</v-btn>
        </template>
      </ob-dialog>
    </template>

    <slot name="fab"></slot>
    <slot name="dialogs"></slot>
  </v-container>
</template>

<script>
import _debounce from 'lodash.debounce'
import _isEqual from 'lodash.isequal'

import rules from '@/helpers/validation'
import draggable from 'vuedraggable'
import Dialog from '@/components/Dialog'
import ColorPicker from '@/components/ColorPicker'
import pwd from 'generate-password'

import FormField from '@/components/FormField'

import translate from '@/mixins/Translate'

export default {
  name: 'admin-section',
  mixins: [translate],
  props: {
    importHeadersBtn: {
      type: Boolean,
      default: false
    },
    hasPerioade: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      required: true
    },
    confirmValue: {
      type: Boolean,
      required: false
    },
    xlsx: {
      type: Boolean,
      default: true
    },
    xlsxdown: {
      type: Boolean,
      default: false
    },
    dialogs: {
      type: Boolean,
      default: true
    },
    extension: {
      type: Boolean,
      default: true
    },
    extensionactions: {
      type: Boolean,
      default: true
    },
    relatedItems: {
      type: Object,
      required: false
    },
    add: {
      type: Boolean,
      default: true
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  components: {
    'ob-dialog': Dialog,
    'ob-draggable': draggable,
    'ob-color-picker': ColorPicker,
    'ob-form-field': FormField
  },
  data: () => ({
    selectedTabIdentifier: null,
    selectedPerioadeTabIdentifier: null,
    tabsUpdate: 1,
    perioadeTabsUpdate: 100,
    headerSearch: null,
    fullText: false,
    upload: {
      dialog: false,
      props: {
        dialog: false,
        accepted: [],
        rejected: []
      },
      import: {
        dialog: false,
        headers: [],
        errors: [],
        tempId: null
      }
    },
    confirm: {
      dialog: false,
      callback: null
    },
    nuke: {
      dialog: false,
      confirm: false
    },
    addProp: {
      dialog: false,
      valid: false,
      values: { value: null, label: null, meaning: null, align: 'left', type: 'string', rules: [], visible: true, sortable: true, index: 7, default: '', noDefault: true, enum: '' },
      search: null,
      selected: null,
      type: 'add',
      fields: { value: null, label: null, meaning: null, align: 'left', type: 'string', rules: [], visible: true, sortable: true, index: 7, default: '', noDefault: true, enum: '' },
      rules: {
        label: [ rules.required ]
      }
    },
    item: {
      dialog: false,
      valid: [],
      values: [],
      type: 'add',
      selected: [],
      currentIndex: null
    },
    relatedSearch: '',
    relatedSearchRapoarte: '',
    relatedSearchHarti: '',
    propTypes: ['string', 'number', 'boolean', 'link', 'datetime', 'date', 'time', 'object', 'array', 'enum', 'files', 'file', 'options', 'dummy', 'colors'],
    importHeaders: {
      dialog: false,
      perioada: null
    }
  }),
  computed: {
    host () {
      return this.$store.getters.host
    },
    token () {
      return this.$store.getters['token']
    },
    tabs () {
      return this.$store.getters[`${this.type}/tabs`]
    },
    perioadeTabs () {
      return this.$store.getters[`${this.type}/perioadeTabs`]
    },
    items () {
      return this.$store.getters[`${this.type}/items`]
    },
    total () {
      return this.$store.getters[`${this.type}/total`]
    },
    headers () {
      const headers = this.$store.getters[`${this.type}/headers`]
      return headers.sort((a, b) => a.index - b.index)
    },
    selectedTab () {
      return this.$store.getters[`${this.type}/selectedTab`]
    },
    selectedTabID () {
      return this.$store.getters[`${this.type}/selectedTabID`]
    },
    selectedPerioadeTab () {
      return this.$store.getters[`${this.type}/selectedPerioadeTab`]
    },
    selectedPerioadeTabID () {
      return this.$store.getters[`${this.type}/selectedPerioadeTabID`]
    },
    visibleHeaders () {
      const h = this.headers.filter(head => head.visible)
      h.unshift({
        '_id': 'itemNO',
        'rules': [],
        'sortable': false,
        'visible': true,
        'default': null,
        'align': 'right',
        'label': '#',
        'meaning': 'numerotare',
        'type': 'number',
        'value': 'itemNO'
      })

      return h
    },
    loading () {
      return this.$store.getters[`${this.type}/loading`]
    },
    restrictedHeaders () {
      return this.$store.getters[`${this.type}/restrictedHeaders`]
    },
    hookHeaders () {
      return this.$store.getters[`${this.type}/hookHeaders`]
    },
    minIndex () {
      return this.$store.getters[`${this.type}/minIndex`]
    },
    pagination: {
      get () {
        return this.$store.getters[`${this.type}/pagination`]
      },
      set (pagination) {
        const { sortBy, descending, page, rowsPerPage } = pagination
        this.$store.dispatch(`${this.type}/paginationChanged`, { sortBy, descending, page, rowsPerPage })
      }
    },
    unique () {
      return this.$store.getters[`${this.type}/unique`]
    },
    tableItemSearch: {
      get () {
        return this.$store.getters[`${this.type}/search`]
      },

      set: _debounce(function (value) {
        this.$store.dispatch(`${this.type}/search`, value)
      }, 500)
    },
    itemNO () {
      if (this.pagination.rowsPerPage === -1) return 1
      return (this.pagination.page - 1) * this.pagination.rowsPerPage + 1
    },

    fileIsToDelete () {
      return (header, index, file) => {
        if (this.item.type === 'edit') {
          return this.item.values[index][`${header}ToRemove`] && this.item.values[index][`${header}ToRemove`].includes(file)
        }

        return false
      }
    },

    lang () {
      return this.$store.getters['dictionar/lang']
    },
    filteredHeaders () {
      return this.headers.filter(head => head.value !== '_id' && !this.hookHeaders.includes(head.value))
    },
    disabledToolbar () {
      return this.type === 'date' && this.selectedTabID === 'info'
    }
  },
  watch: {
    headers (arr) {
      if (Array.isArray(arr) && arr.length && this.addProp.selected) {
        const selected = arr.find(head => head._id === this.addProp.selected._id)
        if (selected) {
          this.$set(this.addProp, 'selected', selected)
        } else {
          this.$set(this.addProp, 'selected', null)
        }
      }
    },
    selectedTab: {
      immediate: true,
      handler () {
        this.addProp.selected = null
        this.item.selected = []
        this.$nextTick(() => {
          if (this.$refs[`tab-${this.selectedTabID}`]) {
            this.$nextTick(() => {
              this.$refs[`tab-${this.selectedTabID}`][0].click()
            })
          }
        })
      // this.forceTabsUpdate()
      }
    },
    selectedTabID: {
      immediate: true,
      handler () {
        this.$nextTick(() => {
          if (this.$refs[`tab-${this.selectedTabID}`]) {
            this.$nextTick(() => {
              this.$refs[`tab-${this.selectedTabID}`][0].click()
            })
          }
        })
      // this.forceTabsUpdate()
      }
    },
    selectedPerioadeTab: {
      immediate: true,
      handler () {
        this.addProp.selected = null
        this.item.selected = []
        this.$nextTick(() => {
          if (this.$refs[`perioadeTab-${this.selectedPerioadeTabID}`]) {
            this.$nextTick(() => {
              this.$refs[`perioadeTab-${this.selectedPerioadeTabID}`][0].click()
            })
          }
        })
      // this.forceTabsUpdate()
      }
    },
    selectedPerioadeTabID: {
      immediate: true,
      handler () {
        this.$nextTick(() => {
          if (this.$refs[`perioadeTab-${this.selectedPerioadeTabID}`]) {
            this.$nextTick(() => {
              this.$refs[`perioadeTab-${this.selectedPerioadeTabID}`][0].click()
            })
          }
        })
      // this.forceTabsUpdate()
      }
    },
    tabs () {
      this.forceTabsUpdate()
    },
    perioadeTabs () {
      this.forceTabsUpdate()
    },
    confirmValue (value) {
      this.confirm.dialog = value
    },
    items (v) {
      if (['indicatori', 'verificare'].includes(this.type) && v.length) {
        setTimeout(() => {
          if (this.$refs.jax) {
            this.$refs.jax.forEach(comp => {
              comp.renderMathJax()
            })
          }
        }, 2000)
      }
    },
    'item.selected' (values) {
      this.$emit('itemsSelected', values.map(item => {
        return item._id
      }))
    },
    'addProp.values.noDefault' (value) {
      if (value) this.addProp.values.default = null
    }
    // not needed anymore
    // relatedSearch: _debounce (function(value) {
    //   this.$store.dispatch(`${this.type}/fetchAllRelated`, value)
    // }, 1000)
  },
  methods: {
    _cbOpenImportHeadersDialog () {
      this.importHeaders.dialog = true
    },
    _cbCloseImportHeaders () {
      this.importHeaders.dialog = false
      this.importHeaders.perioada = null
    },
    _cbDoImportHeaders () {
      this.$store.dispatch(`${this.type}/importHeaders`, { perioada: this.importHeaders.perioada })
      this._cbCloseImportHeaders()
    },
    _cbNukeData () {
      this.nuke.dialog = true
    },
    _cbCloseNuke () {
      this.nuke.dialog = false
      this.nuke.confirm = false
    },
    _cbDoNuke () {
      this.$store.dispatch(`${this.type}/nuke`)
      this._cbCloseNuke()
    },

    _cbAddItem () {
      this.$emit('addItemClicked')
      const obj = {}
      this.headers.filter(head => head.value !== '_id').map(head => {
        if (head.type !== 'boolean') {
          if (head.type === 'enum') {
            this.$set(obj, head.value, head.default)
          } else {
            if (['options', 'array'].includes(head.type)) {
              this.$set(obj, head.value, [])
            } else {
              this.$set(obj, head.value, head.default)
            }
          }
        } else {
          this.$set(obj, head.value, !!head.default)
        }
      })
      this.item.currentIndex = 0
      this.item.values = [obj]
      this.item.dialog = true
    },
    _cbAddProp () {
      if (this.addProp.type === 'add') {
        this.$store.dispatch(`${this.type}/addHeader`, { ...this.addProp.values })
      } else if (this.addProp.selected) {
        this.$store.dispatch(`${this.type}/editHeader`, { values: { ...this.addProp.values }, id: this.addProp.selected._id })
      }
      this._cbClosePropDialog()
    },
    _cbCloseConfirm () {
      this.confirm.dialog = false
      this.confirm.callback = null
    },
    _cbCloseErrorsDialog (mode) {
      // mode: -1 = just close; 0 = cu erori; 1 = doar valid
      if (mode > -1) {
        this.$store.dispatch(`${this.type}/acceptImport`, {
          id: this.upload.import.tempId,
          headers: this.upload.import.headers,
          mode
        })
      }

      this.upload.import.dialog = false
      this.upload.import.headers = []
      this.upload.import.tempId = null
      this.upload.import.errors = []
    },
    _cbCloseItemDialog () {
      this.item.dialog = false
      setTimeout(() => {
        this.item.type = 'add'
        this.$refs.itemForm.reset()
        this.item.currentIndex = null
        this.item.valid = []
        this.item.values = []
        this.item.selected = []
      }, 500)
    },
    _cbClosePropDialog () {
      this.addProp.dialog = false
      this.addProp.type = 'add'
      this.addProp.valid = false
      // this.$refs.addPropForm.reset()
      this.$nextTick(() => {
        Object.keys(this.addProp.values).forEach(key => {
          this.$set(this.addProp.values, key, this.addProp.fields[key])
        })
      })
    },
    _cbCloseUploadDialog (mode) {
      // only close if cancel or x is pressed and we're not parsing the file
      if (!mode && !this.loading) {
        this.upload.dialog = false
        this.$refs.fileForm.reset()
      } else if (mode && this.$refs.file.files[0]) {
        this.processFile(this.$refs.file.files[0])
      }
    },
    _cbCloseUploadPropsDialog (mode) {
      if (!mode) {
        this.upload.props.dialog = false
        this.upload.props.accepted = []
        this.upload.props.rejected = []
        this.upload.props.rows = []
        return
      }

      this.upload.import.headers = this.upload.props.accepted.filter(head => !head._id).map(head => {
        return {
          value: head.value,
          label: head.label || head.value,
          meaning: head.meaning || head.value,
          align: head.align || 'left',
          type: head.type || 'string',
          rules: head.rules || [],
          visible: head.visible || true,
          sortable: head.sortable || true,
          index: head.index || 7,
          default: head.default || ''
        }
      })

      if (!this.upload.import.errors.length) {
        this._cbCloseErrorsDialog(0)
      } else {
        this.openErrorsDialog()
      }

      this.upload.props.dialog = false
      this.upload.props.accepted = []
      this.upload.props.rejected = []
    },
    _cbDeleteItems () {
      this.confirm.dialog = true
      this.confirm.callback = 'deleteItemsConfirmed'
    },
    _cbDeleteProp () {
      this.confirm.dialog = true
      this.confirm.callback = 'deletePropConfirmed'
    },
    _cbDoConfirm () {
      if (this.confirm.callback) this[this.confirm.callback]()
      else this.$emit('confirmed', true)
      this._cbCloseConfirm()
    },
    _cbEditItem () {
      this.$emit('editItemClicked')
      this.item.values = []
      this.item.valid = []
      // if (this.$refs.itemForm) this.$refs.itemForm.reset()
      this.item.selected.forEach((selected, index) => {
        const obj = {}
        this.headers.map(head => {
          this.$set(obj, '_id', selected._id)
          // this.$set(obj, head.value, selected[head.value] && head.type === 'string' ? String(selected[head.value]) : this.getNewObject(head, selected[head.value]))
          this.$set(obj, head.value, this.structuredClone(selected[head.value]))
          // console.log(this.getNewObject(selected[head.value]))
        })
        this.item.values.push(obj)
        this.item.valid.push(!this.validateItem(obj, this.headers, this.itemsValues(null)).length)
      })

      this.item.currentIndex = 0
      this.$nextTick(() => {
        this.item.type = 'edit'
        this.item.dialog = true
        this.$nextTick(() => {
          this.$refs.itemForm.validate()
        })
      })
    },
    _cbEditProp () {
      const keys = Object.keys(this.addProp.fields)
      keys.forEach(key => {
        if (key === 'enum') {
          if (Array.isArray(this.addProp.selected[key])) {
            this.$set(this.addProp.values, key, this.addProp.selected[key].join(', '))
          }
        } else {
          this.$set(this.addProp.values, key, this.addProp.selected[key])
        }
      })
      this.addProp.type = 'edit'
      this.addProp.dialog = true
    },
    _cbExpandRow (props) {
      props.expanded = !props.expanded
    },

    _cbGetFile (raportID, fileIndex, fileName) {
      this.$emit('getFile', { id: raportID, index: fileIndex, file: fileName })
    },

    _cbHeaderSelected (payload) {
      this.$set(this.addProp, 'selected', payload)
    },
    _cbImportAllProps (mode) {
      const from = mode === -1 ? 'accepted' : 'rejected'
      const to = mode === -1 ? 'rejected' : 'accepted'

      this.upload.props[from] = this.upload.props[from].filter(item => {
        if (item.idx === -1) return true
        this.upload.props[to].push(item)
        return false
      })
    },

    _cbItemFilesAdded ($event, index, header, headerType) {
      if (Array.isArray(this.item.values[index][header])) {
        if (headerType === 'files') {
          this.item.values[index][header].push(...$event.target.files)
        } else {
          this.$set(this.item.values[index], header, ...$event.target.files)
        }
      } else {
        if (headerType === 'files') {
          this.$set(this.item.values[index], header, [...$event.target.files])
        } else {
          this.$set(this.item.values[index], header, ...$event.target.files)
        }
      }
    },
    _cbToggleItemRemoveFile (index, header, fileIndex, file) {
      if (this.item.type === 'edit') {
        if (this.fileIsToDelete(header, index, file)) {
          // undo
          this.item.values[index][`${header}ToRemove`] = this.item.values[index][`${header}ToRemove`].filter(f => f !== file)
        } else {
          // remove
          if (this.item.values[index][`${header}ToRemove`]) {
            this.item.values[index][`${header}ToRemove`].push(this.item.values[index][header][fileIndex])
          } else {
            this.item.values[index][`${header}ToRemove`] = [this.item.values[index][header][fileIndex]]
          }
        }
        this.$forceUpdate()
      } else {
        this.item.values[index][header].splice(fileIndex, 1)
      }
    },

    _cbItemsSelected (payload) {
      this.$set(this.item, 'selected', payload)
    },
    _cbMoveBetweenLists (item, index, list) {
      const otherList = list === 'accepted' ? 'rejected' : 'accepted'

      this.upload.props[otherList].push(item)
      this.upload.props[list].splice(index, 1)
    },
    _cbNavEditItem (dir) {
      this.item.currentIndex += dir
      if (this.item.currentIndex < 0) this.item.currentIndex = this.item.selected.length - 1
      else if (this.item.currentIndex > this.item.selected.length - 1) this.item.currentIndex = 0

      setTimeout(() => {
        if (this.$refs.itemForm && this.$refs.itemForm.validate) this.$refs.itemForm.validate()
      }, 1000)
    },
    _cbOpenPropDialog () {
      // this.addProp.values.id = faker.random.uuid()
      this.addProp.dialog = true
    },
    _cbOpenUploadDialog () {
      this.upload.dialog = true
    },
    _cbPullAcceptedItem (event) {
      // return !!this.headers.find(head => head.value === event.draggedContext.element.value)
      return event.draggedContext.element.idx !== -1
    },
    _cbPullRejectedItem (event) {
      return event.draggedContext.element.idx !== -1
    },
    _cbRefreshData () {
      this.$store.dispatch(`${this.type}/fetchTabs`)
      this.$store.dispatch(`${this.type}/fetchHeaders`)
      this.$store.dispatch(`${this.type}/fetchItems`)
    },
    _cbRemoveItemFormRelatedSelection (id, head) {
      const index = this.item.values[this.item.currentIndex][head].findIndex(item => {
        if (typeof item === 'object') return _isEqual(item, id)
        return item === id
      })
      if (index > -1) {
        this.item.values[this.item.currentIndex][head].splice(index, 1)
      }
    },
    _cbSaveItem () {
      if (this.item.type === 'add') {
        const item = this.castNumberProps({ ...this.item.values[0] })
        this.$store.dispatch(`${this.type}/addItem`, item)
      } else if (this.item.selected) {
        this.$store.dispatch(`${this.type}/editItems`, {
          items: this.item.values.map(itm => {
            const item = this.castNumberProps({ ...itm })
            return { ...item }
          })
        })
      }
      this._cbCloseItemDialog()
    },
    _cbSelectTab (id) {
      this.$store.dispatch(`${this.type}/setSelectedTab`, id)
    },
    _cbSelectPerioadeTab (id) {
      this.$store.dispatch(`${this.type}/setSelectedPerioadeTab`, id)
    },
    _cbToggleExpandText () {
      this.fullText = !this.fullText
    },
    _cbToggleHeadVisibility () {
      this.$store.dispatch(
        `${this.type}/toggleHeadVisibility`,
        { id: this.addProp.selected._id, visibility: !this.addProp.selected.visible }
      )
    },

    deleteItemsConfirmed () {
      this.confirm.dialog = false
      this.confirm.callback = null
      this.$store.dispatch(`${this.type}/deleteItems`, { ids: this.item.selected.map(sItem => sItem._id) })
      this.item.selected = []
    },
    deletePropConfirmed () {
      this.confirm.callback = null
      if (this.addProp.selected) {
        this.$store.dispatch(`${this.type}/deleteHeader`, { id: this.addProp.selected._id })
        this.addProp.selected = null
      }
    },
    forceTabsUpdate () {
      this.tabsUpdate++
      this.perioadeTabsUpdate++
    },
    generatePassword () {
      const password = pwd.generate({
        length: 16,
        numbers: true,
        symbols: true,
        uppercase: true,
        exclude: '*()+_-=}{[]|:;"/?.><,`~',
        strict: true
      })
      this.$set(this.item.values[this.item.currentIndex], 'password', password)
    },
    getRules (fieldRules, values, value, head = null, op = null) {
      if (op === 'edit' && head === 'password') {
        fieldRules = fieldRules.filter(rule => rule !== 'required' && rule !== 'min8')
      }

      return fieldRules.map(rule => {
        if (rule === 'unique') {
          let vals = values.map(val => String(val))
          if (value !== null) {
            let removed = false
            vals = vals.filter(val => {
              if (!removed && String(value) === String(val)) {
                removed = true
                return false
              }
              return true
            })
          }

          return rules.unique(vals.map(val => String(val)))
        }
        return rules[rule]
      })
    },
    getRules2AddValueHeader () {
      return [
        rules.required,
        rules.numbersAndLetters,
        rules.max25,
        ...this.getRules(
          ['unique'],
          this.headers.map(h => h.value),
          this.addProp.type === 'add' ? null : this.addProp.selected.value
        )
      ]
    },
    itemsValues (prop = null) {
      if (prop) {
        let values = []
        if (this.unique[prop]) {
          values = this.unique[prop].filter(val => {
            if (this.item.type === 'edit' && this.item.selected.length && this.item.currentIndex !== null) {
              return val !== this.item.selected[this.item.currentIndex][prop]
            }
            return true
          })
        }

        return values
      } else {
        return this.unique
      }
    },
    openErrorsDialog () {
      this.upload.import.dialog = true
    },
    processFile (file) {
      if (file) {
        this.$store.dispatch(`${this.type}/importFromFile`, file).then(result => {
          this.upload.dialog = false
          this.$refs.fileForm.reset()
          if (result) {
            this.upload.props.accepted = result.headers.filter(head => head.selected)
            this.upload.props.rejected = result.headers.filter(head => !head.selected)
            this.upload.import.errors = result.errs
            this.upload.import.tempId = result._id
            this.upload.props.dialog = true
          }
        }).catch(err => {
          this.$store.dispatch('saveMessage', {
            user: this.$store.state.auth.user._id,
            text: `Eroare la procesarea datelor... Detalii: ${err.message || err.error.message}`,
            timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
            type: 'error'
          })
        })
      }
    },
    validateItem (item, headers, values) {
      let valid = []
      headers.forEach(head => {
        const fieldRules = this.getRules(head.rules, values[head.value], item[head.value], head.value)
        fieldRules.forEach(rule => {
          const value = rule(item[head.value])
          if (value !== true) valid.push({ head: head.value, msg: value })
        })
      })

      return valid
    },

    // getNewObject (head, obj) {
    //   if (typeof obj === 'object') {
    //     if (obj instanceof Array) return [...obj]
    //     return { ...obj }
    //   }

    //   if (obj === undefined && head.type === 'array') return []

    //   return obj
    // },

    structuredClone (ob) {
      // structuredClone is available since Chrome 98

      if (typeof window.structuredClone === 'function') return window.structuredClone(ob)
      return JSON.parse(JSON.stringify(ob))
    },

    castNumberProps (item) {
      const newItem = { ...item }
      this.headers.forEach(head => {
        if (head.type === 'number' && !isNaN(item[head.value])) {
          newItem[head.value] = +item[head.value]
        } else {
          newItem[head.value] = item[head.value]
        }
      })

      return newItem
    },

    formatArrayItem (value, head) {
      if (this.relatedItems[head]) {
        switch (head) {
          case 'harti': {
            const relatedItem = this.relatedItems[head].find(r => r._id === value)
            if (relatedItem) return `${relatedItem.denumire}`
            else return value
          }
          case 'rapoarte': {
            const relatedItem = this.relatedItems[head].find(r => r._idCuPerioada === value)
            if (relatedItem) return `${relatedItem.denumire} - ${relatedItem.perioada}`
            else return value
          }
          case 'cifuri': {
            const relatedItem = this.relatedItems[head].find(r => r._id.cif_op === value.cif_op && r._id.cif_os === value.cif_os)
            if (relatedItem) return relatedItem.text
            else return value
          }
          default: return value
        }
      } else {
        return value
      }
    },

    emitDummyEvent (payload) {
      this.$emit('downloadActivity', { payload, type: this.type })
    },
    emitDummyMapEvent (payload) {
      this.$emit('showMap', { payload, type: this.type })
    },
    transformValue (value) {
      // types: 'string', 'number', 'boolean', 'link', 'date' ,'object', 'array', 'enum', 'files', 'file', 'options', 'dummy', 'colors'

      // dummy is used on users to download activity report and on maps to show the preview for some reason... yeah, i know
      // colors isn't implemented, i wanted to use it in the adminmaps service
      // files is used for the reports service (xlsx templates)
      // file is used for the adminmaps service (xlsx template)
      // enum was supposed to be used for the lists service
      // options is actually just an array, used in the rapoarte service to list perioade

      try {
        switch (this.addProp.values.type) {
          case 'string':
            return value ? String(value) : ''
          case 'number':
            return isNaN(value) ? 0 : +value
          case 'boolean':
            return Boolean(value)
          case 'link':
            return /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/.test(value) ? value : 'link invalid'
          case 'datetime':
            return value ? new Date(value).toISOString() : ''
          case 'date':
            return value ? new Date(value).toISOString().slice(0, 10) : ''
          case 'time':
            return /^(?:[01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/.test(value) ? value : ''
          case 'object':
            return value ? JSON.parse(value) : '{}'
          case 'array':
            return value ? JSON.parse(value) : '[]'
          case 'enum':
          case 'files':
          case 'file':
          case 'options':
          case 'dummy':
          case 'colors':
            return value
        }
      } catch (err) {
        console.log(err)
        return 'Valoare netransformabila (null)'
      }
    },

    setValue: _debounce(function (object, property, value) {
      this[object]['values'][property] = value
    }, 500),

    async _cbDownloadXlsx () {
      try {
        const response = await fetch(`${this.host}/download-collection`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: this.token
          },
          body: JSON.stringify({ collection: this.type, perioada: this.selectedPerioadeTabID || this.selectedTabID })
        })

        if (!response.ok) {
          const error = new Error(response.statusText)
          error.response = response
          throw error
        }

        const blob = await response.blob()
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `${this.type}.xlsx`
        link.click()
        window.URL.revokeObjectURL(link.href)
        link.remove()
      } catch (err) {
        console.error(err)
      }
    }
  },
  mounted () {
    if (this.tabs.length && this.selectedTab === null) {
      this.$store.commit(`${this.type}/setSelectedTab`, 0)
    }
  },
  destroyed () {
    this.$store.commit(`${this.type}/clearState`)
  }
}
</script>

<style>
  .ob-grid {
    display: grid;
    grid-template-columns: auto;
  }

  .ob-radio-group-grid .v-input__control {
    flex-grow: 1;
  }

  .ob-radio-group-grid .v-radio {
    margin-bottom: 0 !important;
  }

  .ob-radio-group-grid [role="radiogroup"] {
    display: grid;
    grid-gap: 8px;
  }

  .columns-3, .columns-3 [role="radiogroup"] {
    grid-template-columns: repeat(3, 1fr);
  }
  .columns-4, .columns-4 [role="radiogroup"] {
    grid-template-columns: repeat(4, 1fr);
  }

  .columns-2, .columns-2 [role="radiogroup"] {
    grid-template-columns: repeat(2, 1fr);
  }
</style>
